import RightIcon from "../../assets/Icons/RightIcon"
import { RoundedButton } from "../RoundedButtons"

const EMIDueCard = ({ color, title = "EMI", dueDate, amount }) => {
  return (
    <div
      className={`border-[${color}] rounded-[15px] p-[18px]  relative border bg-white`}
    >
      <div className="grid grid-cols-2">
        <div className="col-span-1 gap-2">
          <p className="font-Apparat font-[600] mt-[4px] text-[10px] leading-[11.6px] tracking-[-2%] text-[#42495280]">
            {title}
          </p>
          <p
            className={`font-Apparat font-[600] text-[12px] md:text-[14px] mt-[4px] leading-[13.92px] md:leading-[16.24px] tracking-[-2%] text-[${color}]`}
          >
            {dueDate}
          </p>
          <p className="font-filson-soft font-[700] text-[16px] md:text-[20px] mt-[4px] leading-[20px] md:leading-[23.2px] tracking-[-2%] text-[#424952]">
            {amount}
          </p>
        </div>
        <div className="col-span-1 flex justify-end">
          <RoundedButton className="!w-[30px] !h-[30px] md:!w-[40px]  md:!h-[40px]">
            <RightIcon />
          </RoundedButton>
        </div>
      </div>
      <div
        className={`absolute top-0 -right-1 h-[15px] rounded-full w-[15px] bg-[${color}]`}
      ></div>
    </div>
  )
}
export default EMIDueCard
